// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dwaRm","col":"styles_col__IxMWv"};